import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, navigate } from 'raviger';
import { Button, Card, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import L from "leaflet";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faInfoCircle, faPlusSquare, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import Header from '../components/Header';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';

function ShelterManagement({ organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [data, setData] = useState({shelters: [],  isFetching: false,});
  //const [selectedShelter, setSelectedShelter] = useState(null);

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchShelters = async () => {
      setData({shelters: [], isFetching: true});
      // Fetch Shelter data.
      await axios.get('/shelter/api/shelter/?organization=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData({shelters: response.data, isFetching: false});
        }
      })
      .catch(error => {
        if (!unmounted) {
          setData({shelters: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };
    fetchShelters();
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [organization]);

  return (
    <>
    <span className="mt-4 ml-auto mr-auto" style={{width:"80%", maxWidth:"80%"}}>
    <Header>
      <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization + '/manage/organization')} className="mr-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
      {state.organization.name} - Manage Shelters
      <OverlayTrigger
        key={"new-shelter"}
        placement="bottom"
        overlay={
          <Tooltip id={`tooltip-new-shelter`}>
            Add new shelter
          </Tooltip>
        }
      >
        <Link style={{cursor:'pointer', marginLeft:'10px'}} href={"/" + organization + '/manage/shelters/new'}>
          <FontAwesomeIcon icon={faPlusSquare} size="sm" inverse />
        </Link>
      </OverlayTrigger>
    </Header>
    <hr/>
    <Row className="flex-nowrap" style={{paddingBottom:"10px"}}>
      <Col style={{minWidth:"150px", maxWidth:"150px", marginLeft:"0px"}}>
          Shelter Name
      </Col>
      <Col style={{minWidth:"325px", maxWidth:"325px", marginLeft:"1px"}}>
          Shelter Address
      </Col>
      <Col style={{minWidth:"85px", maxWidth:"85px"}}>
          Operational
      </Col>
      <Col style={{minWidth:"60px", maxWidth:"60px"}}>
          Training
      </Col>
      <Col style={{minWidth:"75px", maxWidth:"75px"}}>
          Active
      </Col>
      <Col style={{minWidth:"75px", maxWidth:"75px"}}>
          Actions
      </Col>
    </Row>
    {data.shelters.map(shelter => (
      <Card key={shelter.id} className="rounded mb-1" style={{width:"773px"}}>
        <div className="row no-gutters flex-nowrap">
          <Col className="border-top border-left border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", borderTopLeftRadius:"0.25rem", borderBottomLeftRadius:"0.25rem", minWidth:"150px", maxWidth:"150px", backgroundColor:"#615e5e"}}>
            {shelter.name}
          </Col>
          <Col className="border-top border-left border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"325px", maxWidth:"325px", backgroundColor:"#615e5e"}}>
            {shelter.full_address}
          </Col>
          <Col className="border-top border-left border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"85px", maxWidth:"85px", backgroundColor:"#615e5e"}}>
            {shelter.operational ? "Yes" : "No"}
          </Col>
          <Col className="border-top border-left border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"60px", maxWidth:"60px", backgroundColor:"#615e5e"}}>
            {shelter.training ? "Yes" : "No"}
          </Col>
          <Col className="border-top border-left border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"75px", maxWidth:"75px", backgroundColor:"#615e5e"}}>
          {Object.keys(shelter.active_incidents).length > 0 ? (
            <>
              Yes
              <OverlayTrigger
                key={"active-incidents"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-active-incidents`}>
                    {Object.entries(shelter.active_incidents).map(([inc_slug, incident]) => (
                      <span key={inc_slug}>
                        {incident.name} ({incident.animal_count})
                        <br />
                      </span>
                    ))}
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faInfoCircle} className="ml-1 fa-move-up" size="sm" inverse />
              </OverlayTrigger>
            </>
          ) : (
            "No"
          )}
          </Col>
          <Col className="border" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"75px", maxWidth:"75px", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", backgroundColor:"#615e5e"}}>
            <OverlayTrigger
              key={"edit-shelter"}
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-edit-shelter`}>
                  Update shelter
                </Tooltip>
              }
            >
              <Link href={"/" + organization + "/manage/shelters/edit/" + shelter.id}><FontAwesomeIcon icon={faPencil} className="ml-1" inverse /></Link>
            </OverlayTrigger>
          </Col>
        </div>
      </Card>
    ))}
    </span>
    </>
  )
}

export default ShelterManagement
